import React from 'react';
import { metaKeyDisplay } from 'lib/helpers';

function findLinkEntities(contentBlock, callback, contentState) {
	contentBlock.findEntityRanges(
		character => {
			const entityKey = character.getEntity();
			return (
				entityKey !== null &&
				contentState.getEntity(entityKey).getType() === 'LINK'
			);
		},
		callback,
	);
}

function InlineLink({ contentState, entityKey, children }) {
	const { url } = contentState.getEntity(entityKey).getData();
	return (
		<a
			href={url}
			target="_blank"
			style={{ cursor: 'text' }}
			title={`按住 ${metaKeyDisplay} 点击访问 ${url}`}
			onClick={e => (e.ctrlKey || e.metaKey) ? window.open(url, '_blank') : null}>
			{children}
		</a>
	);
};

export const linkDecorator = {
	strategy: findLinkEntities,
	component: InlineLink,
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/linkPlugin/linkDecorator.jsx